import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { sidebar } from './sidebar.reducer';
import { location } from './location.reducer';
import { organisation } from './organisation.reducer';
//import { elements } from './elements.reducer';
import { notifications } from './notifications.reducer';
import { tags } from './tag.reducer';
//import { device } from './device.reducer';
import { navigation } from './navigation.reducer';
import { streams } from './streams.reducer';
import { status } from './status.reducer';
import { userConstants } from '../constants';
import { settings } from './settings.reducer';
//import { features } from './features.reducer';
import { user } from './users.reducer';
import { news } from './news.reducer';

import { api } from '../new_services/api';
import sideFormReducer from '../new_services/forms';
import elementReducer from '../new_services/element';
import toastsReducer from '../new_services/toasts';
//import featuresReducer from '../new_services/toasts';

const appReducer = combineReducers({
  authentication,
  sidebar,
  location,
  organisation,
  //elements,
  notifications,
  tags,
  //device,
  navigation,
  streams,
  status,
  settings,
  //features,
  user,
  news,

  sideForms: sideFormReducer,
  element: elementReducer,
  toasts: toastsReducer,
  //features: featuresReducer,
  [api.reducerPath]: api.reducer,
});

export default (state, action) => {
  if (action.type === userConstants.LOGOUT) {
    state = undefined;
  }
  return appReducer(state, action);
};
